import React, { Fragment,  useContext, useEffect, useState } from 'react'
import operatorContext from '../../../context/operator/operatorContext'
import {useAlert} from "react-alert";

const OperatorBankDetails = () => {

    const alert = useAlert()

    const OperatorContext = useContext(operatorContext);

    const {updateOperatorBankDetails, addOperatorBankDetails, getBanks, operator, clearAlert, getUserBank } = OperatorContext; //has not been created yet tho

    const { banks, message, userBank } = operator;

    const { msg, msg_options} = message;

    const [bankCode, setBankCode] = useState(userBank.bank_code || 801); //first bank in the array

    //const [isFetched, setIsFetched] = useState(false)

    useEffect(() => {

        // if(isFetched === false){
        //     getBanks()
        //     getUserBank()
        //     setIsFetched(true)
        // }
        
        //Get all banks when the component mounts
        if (banks.length === 0) {
            const interval = setInterval(() => {
                getBanks();
                //setIsFetched(true)
              }, 3000);
              return () => clearInterval(interval);
        }

        if(userBank.length === 0){
            const interval = setInterval(() => {
                getUserBank();
              }, 3000);
              return () => clearInterval(interval);
        }

        if (msg !== "") {
            alert.show(
                msg, msg_options
            )
            clearAlert()
        }
        //eslint-disable-next-line
    }, [userBank, msg, msg_options]);

    var bankDetail =  banks.filter( bank => {
        return bank.code === bankCode ? bank.name : ""
    });



    const onSubmit = e => {

        e.preventDefault()

        let bank_details = document.getElementById("bank_details");

        let updated_bank_details = new FormData(bank_details);

        bankDetail.map(bank=>(
           
            updated_bank_details.append('bank_name',  bank.name),
            updated_bank_details.append('bank_id', bank.id)
            )
        )

        updated_bank_details.append("bank_name", bankDetail.bank_name)
        updated_bank_details.append("bank_id", bankDetail.bank_id)

        if(userBank.length === 0){
            addOperatorBankDetails(updated_bank_details)
        }
        else{
           updateOperatorBankDetails(updated_bank_details)
        }
        
    }
    return (
        <Fragment>
            <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Bank Details </h3>
                <p>Update your bank information</p>
                {/* <!--Start Dashboard Content--> */}

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-12">

                            <ul className="profile-tab-view nav nav-pills mb-5" id="pills-tab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active ft-1-5" id="pills-personal-information-tab"
                                        data-toggle="pill" href="#pills-personal-information" role="tab"
                                        aria-controls="pills-personal-information" aria-selected="true">Bank
                                        Information</a>
                                </li> 
                            </ul>
                            <div className="tab-content" id="pills-tabContent">

                                <div className="tab-pane fade show active" id="pills-personal-information" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div className="profile-info-details">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6 col-lg-6">
                                                <form onSubmit={onSubmit} id="bank_details" encType="multipart/form-data">
                                                
                                                    <div className="form-group mb-5">
                                                        <label>Account Number</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='account_number'
                                                            defaultValue={userBank ? userBank.account_number : ""}
                                                            placeholder="8381418144" required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Bank Name</label>
                                                        <select name="bank_code" onChange={e => setBankCode(e.target.value)} value={userBank ? userBank.bank_code : 801} className="form-control form-control-custom-view">
                                                            {banks.length > 0 ?
                                                                banks.map(bankName => (
                                                                    
                                                                    <option value={bankName.code}
                                                                            key={bankName.code}>{bankName.name}  
                                                                    </option>
                                                                ))

                                                                : <option>--Select bank--</option>

                                                            }   
                                                        </select>
                                                    </div>
                                                    

                                                    <div className="form-group mb-5">
                                                        <label>Account Name</label>
                                                        <input type="text" className="form-control form-control-custom-view"
                                                            name='account_name'
                                                            defaultValue={userBank ? userBank.account_name : ""}
                                                            placeholder="Obi Nkemjika Derick" required />
                                                    </div>
                                                    <div className="form-group mb-5">
                                                        <label>Account Type</label>
                                                        <select name="account_type" value={userBank ? userBank.account_type : ""}  className="form-control form-control-custom-view">
                                                            <option value="0">Savings</option>
                                                            <option value="1">Current</option>
                                                        </select>
                                                    </div>
                                                   
                                                    <div className="form-row">
                                                        <div className="form-group col-lg-4">
                                                            <input type="submit" value={userBank.length === 0 ? "ADD BANK" : "UPDATE BANK"} 
                                                                className="btn btn-orange btn-custom-view text-white btn-block d-flex justify-content-center align-items-center"
                                                                    />
                                                           
                                                        </div>
                                                    </div>
                                                </form> 
                                            </div>
                                            <div className="col-md-6 col-sm-6 col-lg-6 ">
                                                <h2 className="text-center">Your Details</h2>
                                                <div className="card  bg-color-3">
                                                    {userBank ? 
                                                    <div className="card-body">
                                                    <div className="media align-items-center mb-3">
                                                        <div className="media-body">
                                                            <h6 className="text-white">ACCOUNT NUMBER</h6>
                                                        </div>
                                                        <div className="text-black">
                                                            <h6>{userBank && userBank.account_number}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="media align-items-center mb-3">
                                                        <div className="media-body">
                                                            <h6 className="text-white">BANK NAME</h6>
                                                        </div>
                                                        <div className="text-black">
                                                            <h6>{userBank && userBank.bank_name}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="media align-items-center mb-3">
                                                        <div className="media-body">
                                                            <h6 className="text-white">ACCOUNT NAME</h6>
                                                        </div>
                                                        <div className="text-black">
                                                            <h6>{userBank && userBank.account_name}</h6>
                                                        </div>
                                                    </div>
                                                    <div className="media align-items-center mb-3">
                                                        <div className="media-body">
                                                            <h6 className="text-white">ACCOUNT TYPE</h6>
                                                        </div>
                                                        <div className="text-black">
                                                            <h6>{userBank && userBank.account_type === 0 ? "SAVINGS" : "CURRENT"}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                : 
                                                <div className="card-body">
                                                    <div className="media align-items-center mb-3">
                                                        No record found...
                                                    </div>
                                                </div>
                                                }
                                                    
                                                </div>
                                            </div>
                                            <div className="col-lg-3">
                                                <a href="!#">
                                                    <div className="position-relative">
                                                        <div className="avatar-holder-profile bord-radius-50 mx-auto">
                                                            <img src="assets/images/avatar-big.png"
                                                                className="img-fluid object-fit-cover object-pos-center h-100 w-100" alt="" />
                                                        </div>
                                                        <img src="assets/images/vector-avatar.png"
                                                            className="img-fluid vector-avatar-overlay" alt="" />
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--End Dashboard Content--> */}

            </div>
            {/* <!-- End container-fluid--> */}

        </div>
        {/* End wrapper */}
       
        </Fragment>
    )
}

export default OperatorBankDetails

